import { addressToMultilineAddress } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { formatReferenceViewID } from '../../../modules/referenceView/index.ts';
import { selectCraftsmanMetadataById } from './selectCraftsmanMetadataById.ts';

export const selectSubjectAddressDisplay = createSelector(
  selectCraftsmanMetadataById,
  (metadata) => {
    const subjectMetadata = metadata[formatReferenceViewID({ type: 'subject' })];
    const addressParts = addressToMultilineAddress(subjectMetadata?.address);

    return {
      street: subjectMetadata?.address?.AddressLineText ?? '',
      full: addressParts.join(' '),
    };
  },
);
